import { Session } from '@/types/session.types';
import sortedSessionsByTimestamp from '@/utils/sorted-sessions-by-timestamp';

export enum ESortOptions {
  upcoming = 'upcoming',
  dateasc = 'dateasc',
  datedesc = 'datedesc',
  az = 'az',
  za = 'za',
}

export const filterSessions = ({
  language,
  sessionSearch,
  sessionTypeFilter,
  sessions,
  sortOption,
}: {
  language?: string;
  sessionSearch: string;
  sessionTypeFilter: Record<string, string> | null;
  sessions: Session[] | undefined;
  sortOption: ESortOptions;
}) => {
  const sortedSessions = sortSessions({ sessions: sessions || [], language, sortType: sortOption });

  const _sessionSearch = sessionSearch.trim().toLowerCase();

  if (!_sessionSearch.length && !sessionTypeFilter?.value) {
    return sortedSessions;
  }

  return sortedSessions.filter((session) => {
    const title = session.title[language || 'base'];
    const description = session.description?.[language || 'base'];
    let titleMatch = false;
    let descriptionMatch = false;
    if (_sessionSearch.length) {
      if (typeof title === 'string') {
        titleMatch = title.toLowerCase().includes(_sessionSearch.toLowerCase());
      }
      if (typeof description === 'string') {
        descriptionMatch = description?.toLowerCase().includes(_sessionSearch.toLowerCase());
      }
    }

    if (sessionTypeFilter?.value) {
      const type = session.session_type;
      const typeMatch = type === sessionTypeFilter.value;
      if (!typeMatch) return false;
      if (!_sessionSearch?.length) return true;
    }

    return titleMatch || descriptionMatch;
  });
};

export const sortSessions = ({
  sessions,
  language,
  sortType,
}: {
  sessions: Session[];
  language?: string;
  sortType: ESortOptions;
}) => {
  let _filteredSessions = [...sessions];
  switch (sortType) {
    case ESortOptions.upcoming: {
      _filteredSessions = _filteredSessions.filter((session) => {
        return !!(session.timestamp && session.end_timestamp);
      });
      _filteredSessions = sortedSessionsByTimestamp(sessions, 'desc');
      break;
    }
    case ESortOptions.dateasc: {
      _filteredSessions = sortedSessionsByTimestamp(sessions, 'asc');
      break;
    }
    case ESortOptions.datedesc: {
      _filteredSessions = sortedSessionsByTimestamp(sessions, 'desc');
      break;
    }
    case ESortOptions.az: {
      _filteredSessions = [..._filteredSessions].sort((a, b) => {
        const titleA = (language && a.title[language]) || a.title['base'];
        const titleB = (language && b.title[language]) || b.title['base'];
        if (typeof titleA === 'string' && typeof titleB === 'string') {
          return titleA.localeCompare(titleB);
        }
        return 0;
      });
      break;
    }
    case ESortOptions.za: {
      _filteredSessions = [..._filteredSessions].sort((a, b) => {
        const titleA = (language && a.title[language]) || a.title['base'];
        const titleB = (language && b.title[language]) || b.title['base'];
        if (typeof titleA === 'string' && typeof titleB === 'string') {
          return titleB.localeCompare(titleA);
        }
        return 0;
      });
      break;
    }
  }

  return _filteredSessions;
};
